export default __webpack_public_path__ + "static/media/childDevelopmentblob3.7b74ed43.svg";